import * as THREE from 'three'


export default class Label3d{
    constructor(text,rotation = 0){
        this.rot = rotation;

        this.label3d = null;
        this.makeLabel3d(text);
    }

    makeLabel3d(text){
        this.canvas = document.createElement('canvas');
        this.canvas.style.border = '1px solid red';
        this.canvas.width = 700;
        this.canvas.height = 150;
        this.ctx = this.canvas.getContext('2d');
        this.texCanvas =  new THREE.Texture(this.canvas);
        this.texCanvas.needsUpdate = true;
        this.ctxMaterial = new THREE.SpriteMaterial( { map: this.texCanvas, depthTest: false, rotation: (this.rot * Math.PI/180)} );
        // let textWidth = this.ctx.measureText(text).width;
        this.ctx.font = 'lighter 100pt Arial';
        this.ctx.textAlign = "left";
        this.ctx.textBaseline = "bottom";
        this.ctx.fillText(text,0, this.canvas.height);
        const sprite = new THREE.Sprite( this.ctxMaterial );
        this.label3d = sprite;
        this.label3d.scale.set(40,8,8);
    };

    getLabel(){
      return this.label3d;
    }

    setScale(scale = 1){
      this.label3d.scale.set(scale * 40, scale * 8, scale * 8)
    }

    setRotation(newAngle = 50){
      this.ctxMaterial.rotation = newAngle * Math.PI/180;
      this.texCanvas.needsUpdate = true;
      this.ctxMaterial.needsUpdate = true;
    }

    setText(newText){
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.fillText(newText,0, this.canvas.height);
      this.texCanvas.needsUpdate = true;
    }
}
